import React from "react";
import * as S from "./notFountPageContent.styles";

interface NotFoundPageContentProps {
  contentText: string;
}

const NotFoundPageContent = ({ contentText }: NotFoundPageContentProps) => {
  return (
    <S.NotFoundPageContentLayout>
      <p>{contentText}</p>
    </S.NotFoundPageContentLayout>
  );
};

export default NotFoundPageContent;
